import style from './style.css';

const OffersCard = (props) => {
  const {
    offerCardClick,
    offerBackgroundImg,
    merchantName,
    offerText,
    index,
  } = props;
  return (
    <div
      className={style.OffersCard}
      onClick={() => {
        offerCardClick();
      }}>
      <div className={style.offerImage}>
        <img src={offerBackgroundImg} alt={`${merchantName}_banner`} />
      </div>
      <div className={style.offerContent}>
        <div className={style.merchantName}>{merchantName}</div>
        <div className={style.offerText}>{offerText}</div>
      </div>
    </div>
  );
};

export default OffersCard;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/offersCard/index.js